import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { SendOtcResponse } from "./sendOtc";

export interface SendPhoneOtcParameters extends NextApiParams {
  phone: string;
  concernId: number;
  evaluatedLocale: string;
}

export const sendPhoneOtc = withNextApi<SendOtcResponse, SendPhoneOtcParameters>(
  "/auth/SendPhoneOtc"
);
